import { render, staticRenderFns } from "./OptionsItemSelectionDialog.vue?vue&type=template&id=875634b6"
import script from "./OptionsItemSelectionDialog.vue?vue&type=script&lang=js"
export * from "./OptionsItemSelectionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports